<template>
    <div class="navbar-container d-flex content align-items-center">
        <!-- Nav Menu Toggler -->
        <ul class="nav navbar-nav d-xl-none">
            <li class="nav-item">
                <b-link
                    class="nav-link"
                    @click="toggleVerticalMenuActive"
                >
                    <feather-icon
                        icon="MenuIcon"
                        size="21"
                    />
                </b-link>
            </li>
        </ul>

        <!-- Left Col -->
        <div class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex">
            <!-- Bookmarks Container -->
            <bookmarks />
        </div>

        <div class="nav align-items-center font-weight-bolder text-primary">{{ appName }}</div>

        <b-navbar-nav class="nav align-items-center ml-auto">
            <locale />
            <dark-toggler class="d-none d-lg-block" />
            <menu-type v-if="!isMobile" />
            <search-bar />
            <notification-dropdown />
            <user-dropdown />
        </b-navbar-nav>
    </div>
</template>

<script setup lang="ts">import { computed as _computed } from 'vue';

import { defineComponent } from 'vue'
import { $themeConfig } from '@themeConfig'
import { BLink, BNavbarNav } from 'bootstrap-vue'
import { isMobile } from 'mobile-device-detect'
import { storeToRefs } from 'pinia'
import Bookmarks from './components/Bookmarks.vue'
import DarkToggler from './components/DarkToggler.vue'
import Locale from './components/Locale.vue'
import MenuType from './components/MenuType.vue'
import NotificationDropdown from './components/NotificationDropdown.vue'
import SearchBar from './components/SearchBar.vue'
import UserDropdown from './components/UserDropdown.vue'
import { getUserData } from '@/auth/utils'
import { useUserData } from '@/module/shared/composables/useUserData'
import { useConfigStore } from '@/store/configStore'

defineProps({
  toggleVerticalMenuActive: { type: Function }
})

const { empresa } = storeToRefs(useConfigStore())
const appName = _computed(() => empresa.value?.nombre ?? $themeConfig.app.appName)
// const appName = getUserData().empresa ? getUserData().empresa : $themeConfig.app.appName
</script>
